import React from "react";
import { useNavigate } from "react-router-dom";
import backIcon from "@assets/icons/back-arrow.svg";
import styles from "./EvaluationPageHeader.module.css";

interface EvaluationPageHeaderProps {
  admissionID: string;
  examSessionName?: string;
  onViewShortcutsClick: () => void;
}

function EvaluationPageHeader({
  admissionID,
  examSessionName,
  onViewShortcutsClick
}: EvaluationPageHeaderProps) {
  const navigate = useNavigate();
  const handleBackToDashboard = () => {
    navigate("/evaluator-dashboard");
  };
  return (
    <div className={styles.evaluatorHeader}>
      <button className={styles.backBtn} onClick={handleBackToDashboard}>
        <img src={backIcon} /> Back to Dashboard
      </button>
      <div className={styles.rightSidePanel}>
      <div className={styles.testInfo}>
        {examSessionName && <h2>Session: {examSessionName}</h2>}
        <p>Admission ID: {admissionID || "N/A"}</p>
      </div>
      <button title="Alt + /" className={styles.viewShortcutsBtn} onClick={onViewShortcutsClick}>
        View Shortcuts
      </button>
      </div>
    </div>
  );
}

export default EvaluationPageHeader;
